import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import { jsx as _jsx } from "react/jsx-runtime";
import { Core } from "@faire/design-tokens";
import React from "react";
/**
 * @trackcomponent
 */ export var HorizontalLine = function(_param) {
    var ref = _param.ref, color = _param.color, margin = _param.margin, stroke = _param.stroke, width = _param.width, styleProp = _param.style, rest = _object_without_properties(_param, [
        "ref",
        "color",
        "margin",
        "stroke",
        "width",
        "style"
    ]);
    var styles = _object_spread_props(_object_spread({
        borderBlockEnd: 0,
        borderInline: 0
    }, color != null ? {
        backgroundColor: color,
        borderColor: color,
        borderStyle: "solid"
    } : {}), {
        inlineSize: width !== null && width !== void 0 ? width : "100%",
        margin: margin !== null && margin !== void 0 ? margin : 0,
        blockSize: stroke !== null && stroke !== void 0 ? stroke : 1,
        borderBlockStart: stroke != null || color != null ? "".concat(stroke || "1px", " solid ").concat(color ? color : Core.border.muted) : "1px solid ".concat(Core.border.muted)
    });
    return /*#__PURE__*/ _jsx("hr", _object_spread_props(_object_spread({}, rest), {
        ref: ref,
        style: _object_spread({}, styles, styleProp)
    }));
};
